// extracted by mini-css-extract-plugin
export var addButton = "_dg-0";
export var border = "_dg-8";
export var check = "_dg-h";
export var danger = "_dg-6";
export var dropdownContainer = "_dg-1";
export var editModalBody = "_dg-j";
export var footerContainer = "_dg-i";
export var fullWidth = "_dg-a";
export var hide = "_dg-9";
export var icon = "_dg-3";
export var input = "_dg-7";
export var inputFlex = "_dg-b";
export var inputWrapper = "_dg-c";
export var manualFocus = "_dg-5";
export var optionButton = "_dg-4";
export var pillWrapper = "_dg-e";
export var pointer = "_dg-2";
export var showOverflow = "_dg-f";
export var tagsFlex = "_dg-d";
export var xButton = "_dg-g";